<template>
  <div class="cardClubSkeleton">
    <div class="cardClubSkeleton__logo">
      <div class="skeletonLoading !rounded-full  w-24 h-24" />
    </div>
    <div class="cardClubSkeleton__title skeletonLoading" />
    <div class="cardClubSkeleton__button skeletonLoading" />
  </div>
</template>

<style lang="scss">
.cardClubSkeleton {
  @apply flex flex-col items-center max-w-[207px] h-[237px]
  overflow-hidden cursor-wait
  transition duration-100
  hover:shadow-2xl;
  background-color: var(--base-card-bgColor);
  border-radius: var(--base-border-radius);

  .cardClubSkeleton__logo {
    @apply w-full object-cover rounded-t-sm h-full relative
    flex items-center justify-center;
  }

  .cardClubSkeleton__title {
    @apply relative bottom-6 p-3 w-[150px];
  }
  .cardClubSkeleton__button {
    @apply w-full p-4;
  }
}
</style>
